export const loadImages = (urls, callback) => {
  return Promise.allSettled(
    (urls ?? []).map(
      (url) =>
        new Promise((resolve, reject) => {
          if (!url) resolve('');
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = url;
          img.onload = () => {
            callback?.();
            resolve(img);
          };
          img.onerror = () => {
            callback?.();
            reject();
          };
        }),
    ),
  );
};

export const preloadImage = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
  });
};
